import { render, staticRenderFns } from "./LinkBranchStaffModal.vue?vue&type=template&id=187f264b&"
import script from "./LinkBranchStaffModal.vue?vue&type=script&lang=js&"
export * from "./LinkBranchStaffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('187f264b')) {
      api.createRecord('187f264b', component.options)
    } else {
      api.reload('187f264b', component.options)
    }
    module.hot.accept("./LinkBranchStaffModal.vue?vue&type=template&id=187f264b&", function () {
      api.rerender('187f264b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/LinkBranchStaffModal.vue"
export default component.exports